import{getDefaultStore}from'jotai';export const jotaiDefaultStore=getDefaultStore();